import React from "react";
import a23logo from "../assets/a23_avatar_logo.png";
import closeIcon from '../assets/close.png'
import detailArrow from '../assets/revamp-assets/detailArrow.png'
import { connect } from "react-redux";
import { toggleModalAction } from '../redux/actions/userAction'
import { getNewBanners, getNewBonus } from "../Services/userService";
import giftBox from '../assets/revamp-assets/giftbox.png'
import hornIcon from '../assets/revamp-assets/promotion.png'
import foryou from '../assets/revamp-assets/foryou.png'
import navarrow from "../assets/back_btn.png";
import Loading from "../models/Loading";
import './SB2Style.css'
import { WebToNativeMessage } from "../Common/Utils";
import TitleIcon from "../assets/a23bonussummary/titleIcon.png"
class Promotions extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isBonusLoading: true,
            isBannerLoading: true,
            token: "",
            channel: "",
            _id: "",
            errors: {
                message: ""
            },
            username: "",
            aceLevel: "",
            newBonusSummaryData: { listOfBonus: [] },
            newBanners: { promotionalBanners: [] },
            userid: "",
            wagerRatio: 0,
            wagerReleaseRatio: 0,
            currentBonus: [],
            levelDetails: [],
            bonusInfoStatus: false,
            PPRBonusInfoStatus: false,
            enableHeader: 'Y',
            listOfBonus: [],
            PRBonus: [],
            CTBannerData: [],
            allBanners: []
        };
    }

    getActiveOffersDataInWallet = async () => {
        try {
            console.log("AO TRY BLOCK")
            this.setState({
                token: window.sessionStorage["token"],
                a23token: window.sessionStorage["a23token"],
                channel: window.sessionStorage["channel"],
                _id: window.sessionStorage["userid"]
            })
            // console.log("AO TRY BLOCK 2")
            if (window.sessionStorage["CTBannerData"] && window.sessionStorage["CTBannerData"] !== undefined) {
                this.setState({
                    CTBannerData: JSON.parse(window.sessionStorage["CTBannerData"])
                })
            }
            // console.log("AO TRY BLOCK 3")
            await getNewBonus(window.sessionStorage['token'], window.sessionStorage['channel']).then((res) => {
                // console.log("THIS IS THE NEW API THAT IS WORKING: ", res)
                this.setState({
                    newBonusSummaryData: res.data,
                    listOfBonus: res.data.listOfBonus.filter((bonus) => this.verifyExpiry(bonus) === false),
                    PRBonus: res.data.purhcasePRbonus ? res.data.purhcasePRbonus : [],
                    isBonusLoading: false,
                })
                let arr = [{
                    bonusCategory: "PROMO", bonusCode: "PROMOB4", bonusExpiryAt: "0 days", bonusPercent: "50", bonusType: "promo", expiryDate: "1690309800", hiddenBonusFlag: false, issuedOn: "1689744900",
                    levelDetails:
                        [
                            {
                                "minPurchase": "1",
                                "maxPurchase": "30000",
                                "bonusPercent": "50",
                                "instantBonusPercentage": "100",
                                "flatInstantBonus": "0",
                                "lockedBonusPercentage": "0",
                                "lockedBonusReleaseRatio": [
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1"
                                ]
                            }
                        ],
                    maxBonus: "15000",
                    minPurchase: "1",
                    minimum_first_purchase: 0,
                    validDays: "0",
                    welcomeBonus: false
                }, {
                    bonusCategory: "PROMO", bonusCode: "PROMOB4", bonusExpiryAt: "0 days", bonusPercent: "50", bonusType: "promo", expiryDate: "1690309800", hiddenBonusFlag: false, issuedOn: "1689744900",
                    levelDetails:
                        [
                            {
                                "minPurchase": "1",
                                "maxPurchase": "30000",
                                "bonusPercent": "50",
                                "instantBonusPercentage": "100",
                                "flatInstantBonus": "0",
                                "lockedBonusPercentage": "0",
                                "lockedBonusReleaseRatio": [
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1"
                                ]
                            }
                        ],
                    maxBonus: "15000",
                    minPurchase: "1",
                    minimum_first_purchase: 0,
                    validDays: "0",
                    welcomeBonus: false
                }, {
                    bonusCategory: "PROMO", bonusCode: "PROMOB4", bonusExpiryAt: "0 days", bonusPercent: "50", bonusType: "promo", expiryDate: "1690309800", hiddenBonusFlag: false, issuedOn: "1689744900",
                    levelDetails:
                        [
                            {
                                "minPurchase": "1",
                                "maxPurchase": "30000",
                                "bonusPercent": "50",
                                "instantBonusPercentage": "100",
                                "flatInstantBonus": "0",
                                "lockedBonusPercentage": "0",
                                "lockedBonusReleaseRatio": [
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1"
                                ]
                            }
                        ],
                    maxBonus: "15000",
                    minPurchase: "1",
                    minimum_first_purchase: 0,
                    validDays: "0",
                    welcomeBonus: false
                },
                {
                    bonusCategory: "PROMO", bonusCode: "PROMOB4", bonusExpiryAt: "0 days", bonusPercent: "50", bonusType: "promo", expiryDate: "1690309800", hiddenBonusFlag: false, issuedOn: "1689744900",
                    levelDetails:
                        [
                            {
                                "minPurchase": "1",
                                "maxPurchase": "30000",
                                "bonusPercent": "50",
                                "instantBonusPercentage": "100",
                                "flatInstantBonus": "0",
                                "lockedBonusPercentage": "0",
                                "lockedBonusReleaseRatio": [
                                    "CallBreak:10:1",
                                    "Carrom: 10:1",
                                    "Rummy: 10:1"
                                ]
                            }
                        ],
                    maxBonus: "15000",
                    minPurchase: "1",
                    minimum_first_purchase: 0,
                    validDays: "0",
                    welcomeBonus: false
                }];
                console.log("List of arr arr arr arrr dsfdsfdsf", arr);




                this.setState({
                    dummyTestBonus: arr
                })
                // console.log('LIST OF BONUSES: ', window.sessionStorage["totalBalance"] > this.state.listOfBonus[0].minPurchase)
                WebToNativeMessage({
                    type: "redeemCTEvent", eventName: "PF_C_RTN_offerspageview", eventProperties: {
                        acelevel: window.sessionStorage["aceLevel"],
                        channel: window.sessionStorage["channel"],
                        subscriptionType: window.sessionStorage["subscriptionType"],
                        userId: window.sessionStorage["userid"],
                        username: window.sessionStorage["screenName"],
                        wallet_balance: window.sessionStorage["totalBalance"],
                        Click_timestamp: new Date().toLocaleTimeString(),
                        bonusAvailability: this.state.listOfBonus.length > 0,
                        bonus_code_1: this.state.listOfBonus[0] !== undefined ? window.sessionStorage["totalBalance"] > this.state.listOfBonus[0].minPurchase : 'NA',
                        bonus_code_2: this.state.listOfBonus[1] !== undefined ? window.sessionStorage["totalBalance"] > this.state.listOfBonus[1].minPurchase : 'NA',
                        bonus_code_3: this.state.listOfBonus[2] !== undefined ? window.sessionStorage["totalBalance"] > this.state.listOfBonus[2].minPurchase : 'NA',
                    }
                })
            })
            // console.log("AO TRY BLOCK 4")
            await getNewBanners(window.sessionStorage['a23token']).then((res) => {
                console.log('NEW BANNER DATA IS: ', res.data)
                if (window.sessionStorage["CTBannerData"] && window.sessionStorage["CTBannerData"] !== undefined) {
                    this.setState({
                        newBanners: res.data,
                        allBanners: JSON.parse(window.sessionStorage["CTBannerData"])
                            .filter((banner) => banner.imageUrl !== undefined)
                            .sort((a, b) => a.order - b.order)
                            .concat(res.data.promotionalBanners
                                .filter((banner) => banner.active === true)
                                .sort((a, b) => a.order - b.order)),
                        isBannerLoading: false,
                    })
                    // console.log('All Sorted Banners: ', this.state.CTBannerData.filter((banner) => banner.imageUrl !== undefined).sort((a, b) => a.order - b.order))
                } else {
                    this.setState({
                        newBanners: res.data,
                        isBannerLoading: false,
                    })
                }
            })
            // console.log("AO TRY BLOCK 5")
            var screenValue = "";
            if (window.sessionStorage["channel"] == "A23APS" || window.sessionStorage["channel"] == "A23IPS") {
                screenValue = "P_BonusSummary";
            } else if (window.sessionStorage["channel"] == "FAPS" || window.sessionStorage["channel"] == "FIPS") {
                screenValue = "FS_P_BonusSummary";
            } else {
                screenValue = "R_BonusSummary"
            }
            if (window.sessionStorage !== undefined) {
                WebToNativeMessage({ type: "screenNameEvent", screenName: screenValue })
            }
        } catch (err) {
            // console.log("Error in getActiveOffersInWallet")
        }
    }

    verifyExpiry = (bonus) => {
        if ((bonus.expiryDate * 1000) > Date.now()) {
            //Not yet Expired
            return false
        } else {
            // Expired Condition
            return true
        }
    }

    async componentWillMount() {
        this.getActiveOffersDataInWallet()
        const searchParams = new URLSearchParams(this.props.location.search).get("enableHeader")
        this.setState({
            enableHeader: searchParams
        })
        window.sessionStorage.setItem("enableHeader", searchParams)
    }

    async componentDidMount() {
        // console.log("ACTIVE OFFERS MOUNTED")
    }

    navigateToBonusSummary = () => {
        window.sessionStorage.setItem("isfrom", "activeoffers")
        this.props.history.push('/bonussummary/')
    }

    handleBannerClick = (CTMessage, deepLink) => {
        console.log(`Came to Banner Click >>> `, CTMessage)
        console.log(`Deeplink is >>> `, deepLink)
        WebToNativeMessage(CTMessage)
        WebToNativeMessage(deepLink)
    }

    handleBackBtnClick = (msg) => {
        WebToNativeMessage(msg)
        window.sessionStorage["CTBannerData"] = "";
    }

    handleBonusDetailsPopup = (bonusData) => {
        let insdf = [{
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        }, {
            "minPurchase": "25",
            "maxPurchase": "99",
            "bonusPercent": "100",
            "instantBonusPercentage": "0",
            "flatInstantBonus": "5",
            "lockedBonusPercentage": "100",
            "lockedBonusReleaseRatio": [
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Carrom:10:1",
                "Fantasy: 5:1",
                "Rummy: 15:1"
            ]
        },]
        this.setState({ currentBonus: bonusData })
        this.setState({ levelDetails: bonusData.levelDetails })
        // this.setState({ levelDetails: insdf })
        this.setState({ bonusInfoStatus: true })
        this.setState({ maxBonusValue: bonusData.maxBonus })
        document.body.style.overflow = "hidden"
    }

    handlePPRBonusDetailsPopup = (bonusData) => {
        this.setState({ currentBonus: bonusData })
        this.setState({ PPRBonusInfoStatus: true })
        document.body.style.overflow = "hidden"
    }

    getDateSuffix = (num) => {
        const nth = function (d) {
            if (d > 3 && d < 21) return 'th';
            switch (d % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        }
        let suffix = nth(num)
        return suffix
    }

    render() {
        return (
            <>
                {(this.state.isBonusLoading) ?
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        {/* <Loading /> */}
                    </div>
                    :
                    <div style={{ position: 'sticky', top: '0', minWidth: '100vw' }}>
                        <div className={(this.state.bonusInfoStatus || this.state.PPRBonusInfoStatus) ? 'maskedWallet' : ''}>
                            {/* If Enable Header === Y in URL params, we should render navbar. */}
                            {this.state.enableHeader === 'Y' ?
                                <nav className='navbar'>
                                    <div className="nav-container" >
                                        <img
                                            className='backBtn'
                                            src={navarrow}
                                            style={{ width: "40px" }}
                                            onClick={() => this.handleBackBtnClick({ type: "closeClient" })}
                                        />
                                        {/* <p className="nav-text" style={{ textAlign: 'center' }}>My Offers</p> */}
                                        <p className="nav-text" style={{ textAlign: 'center' }}>Offers</p>
                                        <div></div>
                                    </div>
                                </nav>
                                :
                                null
                            }
                            <div className="summaryBonusContainer innerSection">
                                {/* Top Blue Section */}
                                {/* <div className="bonusSummaryDetails">
                                    <div className="bonusSummaryHeader">
                                        <span className="titleStyle bonusSummaryTitle">Bonus Summary</span>
                                        <div onClick={() => this.navigateToBonusSummary()}><span className="viewDetailsLink">View Details</span></div>
                                    </div>
                                    <div className="bonusSummaryGrid">
                                        <div className="gridItem">
                                            <div className="issuedBonus">
                                                <span className="gridTitle">Issued</span> */}
                                {/* <span className="gridData issuedText">2000000000</span> */}
                                {/* <span className="gridData"><span className="rupeeSmall">&#8377;</span>{this.state.newBonusSummaryData.totalIssuedBonus && Math.ceil(Number(this.state.newBonusSummaryData.totalIssuedBonus))}</span>
                                            </div>
                                        </div>
                                        <div className="gridItem">
                                            <div className="expiredBonus">
                                                <span className="gridTitle">Unlocked</span> */}
                                {/* <span className="gridData issuedText">2000</span> */}
                                {/* <span className="gridData"><span className="rupeeSmall">&#8377;</span>{this.state.newBonusSummaryData.totalReleasedBonus && Math.ceil(Number(this.state.newBonusSummaryData.totalReleasedBonus))}</span>
                                            </div>

                                        </div>
                                        <div className="gridItem">
                                            <div className="expiredBonus">
                                                <span className="gridTitle">Expired</span> */}
                                {/* <span className="gridData issuedText">2000</span> */}
                                {/* <span className="gridData"><span className="rupeeSmall">&#8377;</span>{this.state.newBonusSummaryData.totalExpiredBonus && Math.ceil(Number(this.state.newBonusSummaryData.totalExpiredBonus))}</span>
                                            </div>
                                        </div>
                                        <div className="gridItem">
                                            <div className="lockedBonus">
                                                <span className="gridTitle">Locked</span> */}
                                {/* <span className="gridData lockedBonusText">2000</span> */}
                                {/* <span className="gridData lockedBonusText"><span className="rupeeSmall">&#8377;</span>{this.state.newBonusSummaryData.totalLockedBonus && Math.ceil(Number(this.state.newBonusSummaryData.totalLockedBonus))}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                {/* Top code is for header bonus details section */}

                            
                                {/* Need to remove the code and add  in seperate file and routing */}


                                {this.state.isBannerLoading ?
                                    <div className="otherOffersContainer">
                                        <span className="titleStyle">Promotions</span>
                                        <div className="banners" style={{ position: 'absolute', width:'100%',height:'100vh',display:'flex' ,alignItems:'center',justifyContent:"center",top:"0px",left:'0px'}}>
                                            <Loading />
                                        </div>
                                    </div>
                                    :
                                    (this.state.allBanners.length !== 0) ?
                                        <div className="otherOffersContainer" style={{  }}>
                                            <span className="titleStyle">Promotions</span>
                                            <div className="banners">
                                                {
                                                    this.state.allBanners.map((banner, index) => {
                                                        console.log("banner >>>>>>>",banner);
                                                        if (index < 3) {
                                                            if (banner.imageUrl) {
                                                                return (<div key={index + banner.order} onClick={() => this.handleBannerClick({
                                                                    type: "redeemCTEvent", eventName: "Bannerclick", eventProperties: {
                                                                        aceLevel: window.sessionStorage["aceLevel"],
                                                                        username: window.sessionStorage["screenName"],
                                                                        bannerNumber: banner.order
                                                                    }
                                                                }, { type: banner.Location, token: window.sessionStorage["token"], from: "activeoffers" })} style={{ width: '100%', margin: '1.2rem 0rem' }}>
                                                                    <img style={{ width: '100%' }} src={banner.imageUrl}></img>
                                                                </div>)
                                                            } else if (banner.image) {
                                                                return (<div key={index + banner.order} onClick={() => {

                                                                    console.log('Came to Handle ')
                                                                    console.log('Deep link >>> ', banner.deepLink)
                                                                    this.handleBannerClick(
                                                                    
                                                                    {
                                                                    type: "redeemCTEvent", eventName: "Bannerclick", eventProperties: {
                                                                        aceLevel: window.sessionStorage["aceLevel"],
                                                                        username: window.sessionStorage["screenName"],
                                                                        bannerNumber: banner.order
                                                                    }
                                                                }, {
                                                                    type: (banner.deepLink.toLowerCase().includes('tourney') ) ? banner.deepLink :  
                                                                             (banner.deepLink.toLowerCase().includes('opentargetedwebview') || banner.deepLink.toLowerCase().includes('redirectionoutsideapp')) ? banner.deepLink : 
                                                                             banner.deepLink.replace('Location-', '') ,

                                                                    token: window.sessionStorage["token"], from: "activeoffers"
                                                                })}
                                                                } style={{ width: '100%', margin: '1.25rem 0rem' }}>
                                                                    <img style={{ width: '100%' }} src={banner.image}></img>
                                                                </div>)
                                                            } else {
                                                                return null
                                                            }
                                                        } else {
                                                            return null
                                                        }
                                                    })
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div className="availableBonusContainer">
                                            <span className="titleStyle">Promotions</span>
                                            <div className="noAvailableBonusesSection" style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <img style={{ width: '50px' }} src={hornIcon}></img>
                                                <span style={{ marginTop: '1.5rem', color: '#032146', textAlign: 'center', letterSpacing: '-0.5px' }}>Watch out for upcoming promotions</span>
                                            </div>
                                        </div>
                                }
                                {/* <AcePoints /> */}
                            </div>
                        </div>
                        <div className={this.state.bonusInfoStatus ? "redeemableBalanceInfo" : "noDisplay"}>
                            <div style={{ width: '50px', position: 'absolute', top: '-25px', left: '50%', transform: 'translate(-50%)' }}>
                                <img style={{ width: '100%' }} src={a23logo}></img>
                            </div>
                            <div className="infoHeader">
                                <img src={closeIcon} className="closeButton" onClick={() => { this.setState({ bonusInfoStatus: false }); document.body.style.overflow = "scroll" }}></img>
                            </div>
                            <div className="infoTitle">
                                <span>{this.state.currentBonus.bonusCode} Bonus Details</span>
                            </div>
                            <div className="infoTable">
                                <table className="myTable">
                                    <thead>
                                        <tr className="myRow">
                                            <th className="myTH bonusPopup">Add Cash<br></br>{'('}in Rs.{')'}</th>
                                            <th className="myTH bonusPopup">Bonus%</th>
                                            <th className="myTH bonusPopup">Max Bonus<br></br>{'('}in Rs.{')'}</th>
                                            <th className="myTH bonusPopup">Locked Bonus Release Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {/* maxBonus */}


                                        {this.state.levelDetails.length !== 0 && this.state.levelDetails.map((level, index) => {
                                            return (
                                                <tr className="myRow">
                                                    <td className="tableCell">{level.minPurchase} - {level.maxPurchase}</td>
                                                    <td className="tableCell">{level.bonusPercent}%<br></br>{'(' + level.lockedBonusPercentage + '% Locked)'}</td>
                                                    <td className="tableCell">Locked: {((level.maxPurchase * (level.bonusPercent / 100)) > Number(this.state.maxBonusValue)) ? parseInt(Number(this.state.maxBonusValue) - Number(level.flatInstantBonus)) : parseInt(level.maxPurchase * (level.bonusPercent / 100))}   <br></br> Instant: {level.flatInstantBonus}</td>
                                                    <td className="tableCell">{level.lockedBonusReleaseRatio.map((item, index) => {
                                                        return (
                                                            <div key={index + 'lbrt'}>
                                                                {item}<br></br>
                                                            </div>
                                                        )
                                                    })}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>
                            <ul className="myUL">
                                {/* <li className="myLI">Bonus will expire within {this.state.currentBonus.validDays} days from issue date</li> */}
                                {/* <li className="myLI">Bonus will expire within {this.state.currentBonus.bonusExpiryAt} days from issue date</li> */}
                                <li className="myLI">Bonus code is valid till {new Date(Number(this.state.currentBonus.expiryDate * 1000)).toLocaleDateString('en-GB')}, {new Date(Number(this.state.currentBonus.expiryDate * 1000)).toLocaleTimeString('en-AU', { hour: 'numeric', minute: 'numeric', hour12: true,hourCycle: 'h12' })}</li>
                                <li className="myLI">Locked bonus can be unlocked with in {this.state.currentBonus.bonusExpiryAt} days from issue date {this.state.currentBonus?.redeemRemainingToExpire>0 && `or until ${this.state.currentBonus?.redeemRemainingToExpire===1 ? 'Next' : this.state.currentBonus?.redeemRemainingToExpire }${this.state.currentBonus?.redeemRemainingToExpire>1 ? this.getDateSuffix(this.state.currentBonus?.redeemRemainingToExpire) : ''} withdraw`  }</li> 
                                {/* <li className="myLI">For details regarding locked bonus, visit 'Menu'  {'>'}  'Promotions'  {'>'}  'Bonus Summary'</li> */}
                                <li className="myLI">Released bonus added to the wallet in chunks as per your acelevel</li>
                                <li className="myLI">A23 Games T{'&'}C Apply</li>


                            </ul>
                        </div>
                        <div className={this.state.PPRBonusInfoStatus ? "redeemableBalanceInfo" : "noDisplay"}>
                            <div style={{ width: '50px', position: 'absolute', top: '-25px', left: '50%', transform: 'translate(-50%)' }}>
                                <img style={{ width: '100%' }} src={a23logo}></img>
                            </div>
                            <div className="infoHeader">
                                <img src={closeIcon} className="closeButton" onClick={() => { this.setState({ PPRBonusInfoStatus: false }); document.body.style.overflow = "scroll" }}></img>
                            </div>
                            <div className="infoTitle">
                                <span>{this.state.currentBonus.bonusCode} Bonus Details</span>
                            </div>
                            <div className="infoTable">
                                <table className="myTable">
                                    <thead>
                                        <tr className="myRow">
                                            {/* <th className="myTH bonusPopup">Add Cash<br></br>{'('}in Rs.{')'}</th> */}
                                            <th className="myTH bonusPopup">Bonus%</th>
                                            <th className="myTH bonusPopup">Max Bonus<br></br>{'('}in Rs.{')'}</th>
                                            <th className="myTH bonusPopup">Locked Bonus Release Ratio</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="myRow">
                                            <td className="tableCell">{this.state.currentBonus.instantBonusPercent}</td>
                                            <td className="tableCell">{this.state.currentBonus.bonusValue}</td>
                                            {(this.state.currentBonus.wagerReleaseRatio !== undefined) &&
                                                Object.keys(this.state.currentBonus.wagerReleaseRatio).length !== 0 ?
                                                <td className="tableCell">{Object.keys(this.state.currentBonus.wagerReleaseRatio).map((key, index) => {
                                                    return (
                                                        <div key={index + 'lbrt'} style={{ textTransform: 'capitalize' }}>
                                                            {key + " : " + this.state.currentBonus.wagerReleaseRatio[key].wagerRatio + ":" + this.state.currentBonus.wagerReleaseRatio[key].wagerReleaseRatio}<br></br>
                                                        </div>
                                                    )
                                                })}</td>
                                                :
                                                null
                                            }
                                        </tr>
                                    </tbody>
                                </table>
                                <ul className="myUL">
                                    <li className="myLI">Bonus will expire within {this.state.currentBonus.claimValidity} days from issue date</li>
                                    <li className="myLI">Bonus code is valid till {new Date(Number(this.state.currentBonus.bonusEndDate * 1000)).toLocaleDateString('en-GB')}, {new Date(Number(this.state.currentBonus.bonusEndDate * 1000)).toLocaleTimeString('en-GB', { hour: 'numeric', minute: 'numeric', hour12: true })}</li>
                                    <li className="myLI">Bonus release criteria depends as per Ace Level</li>
                                    <li className="myLI">A23 Games T{'&'}C Apply</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                }
            </>
        )
    }
}
const mapStateToProps = state => ({
    userState: state.userState
});

export default connect(
    mapStateToProps,
    { toggleModalAction }
)(Promotions);
